
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconChartPieSelector = "fhi-icon-chart-pie";

/**
 * ## FhiIconChartPie
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-chart-pie
 * @element fhi-icon-chart-pie
 */
@customElement(FhiIconChartPieSelector)
export class FhiIconChartPie extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M7.7 2.143a.75.75 0 0 1 .6 1.375 9.251 9.251 0 0 0 1.037 17.336 9.25 9.25 0 0 0 11.182-5.256.75.75 0 0 1 1.382.585 10.751 10.751 0 0 1-20.47-6.155 10.75 10.75 0 0 1 6.27-7.885m5.372-.839a10.75 10.75 0 0 1 9.624 9.623c.104 1.041-.753 1.822-1.696 1.822L13 12.75A1.75 1.75 0 0 1 11.25 11V3c0-.942.781-1.8 1.823-1.696m-.15 1.493a.13.13 0 0 0-.108.04.23.23 0 0 0-.065.163v8a.25.25 0 0 0 .25.25h8l.052-.005a.22.22 0 0 0 .113-.06.13.13 0 0 0 .04-.108 9.25 9.25 0 0 0-8.282-8.28"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
